import React, { Component } from "react";
import moment from "moment";
import { GrantTable } from "../../../../../Grants/Pages/GrantsActivity/style";
import GrantSearch from "./GrantSearch";
import { isEmpty, orderBy } from "lodash";

export default class Exchanges extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFilterUsed: false,
      menu: [],
      filteredData: [],
      original: this.props.data,
      noData: false,
      fSearch: "", //filters
      fStatus: "",
      fDates: "",
      oneTimeStatus: [],
      recurringStatus: [],
      sorterInfo: {}
    };
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    let menu = [];
    const { data, tab, exportDataUpdate } = this.props;
    exportDataUpdate({ [tab === "1" ? 'singleExchange': 'recurringExchange']: data });
    this.props.data &&
      this.props.data.map((each, index) => {
        menu.push(each.status);
      });
    this.setState({ menu });
  }

  onChangeHandler(sorter, extra){
    const { currentDataSource } = extra;
    const { order, columnKey } = sorter;
    const { tab, exportDataUpdate } = this.props;
    exportDataUpdate({ [tab === "1" ? 'singleExchange': 'recurringExchange']: currentDataSource });
    this.setState({ sorterInfo: { order, columnKey }})
  }

  handleSearch = (filters, isOneTime = false, isRecurring = false) => {
    const { frequency, yearly, status, reStatus } = filters;
    let filteredData = [...this.state.original];
    let oneTimeStatus = [...this.state.oneTimeStatus];
    let recurringStatus = [...this.state.recurringStatus];
    let isOneStatus = this.state.isOneStatus;
    let isRecurringStatus = this.state.isRecurringStatus;
    if (frequency) {
      let ogData = filteredData;
      let filtered = "";
      let temp = [];
      if (frequency.length == 1) {
        const filteredSearch = ogData.filter(x => {
          if (frequency == "Custom") {
            return (
              x.frequency[0] !== "Anually" ||
              x.frequency[0] !== "Quarterly" ||
              x.frequency[0] !== "Monthly"
            );
          } else {
            return x.frequency == frequency;
          }
        });
        filteredData = filteredSearch;
      }
      if (frequency.length > 1) {
        frequency.forEach(item => {
          filtered = ogData.filter(x => {
            if (frequency == "Custom") {
              return (
                x.frequency[0] !== "Anually" ||
                x.frequency[0] !== "Quarterly" ||
                x.frequency[0] !== "Monthly"
              );
            } else {
              return x.frequency == item;
            }
          });
          filtered.forEach(x => temp.push(x));
          filtered = [...temp.flat()];
          filteredData = filtered;
        });
      }
    }

    //Status
    if (status) {
      let filtered;
      let temp = [];
      let filteredStatus = "";
      let ogData = filteredData;
      if (status.length == 1) {
        filteredStatus = ogData.filter(x => x.status.extDescription == status);
        filteredData = filteredStatus;
      }
      console.log("temp1",temp);
      if (status.length > 1) {
        status.forEach(item => {
          filtered = ogData.filter(x => x.status.extDescription == item);
          filtered.forEach(x => temp.push(x));
          const test = temp.flat();
          console.log("temp2",test);
          filteredStatus = [...test];
          filteredData = filteredStatus;
        });
      }
    }

    if (reStatus) {
      let filtered;
      let temp = [];
      let filteredStatus = "";
      let ogData = filteredData;
      if (reStatus.length == 1) {
        filteredStatus = ogData.filter(x => x.status == reStatus);
        filteredData = filteredStatus;
      }
      if (reStatus.length > 1) {
        reStatus.forEach(item => {
          filtered = ogData.filter(x => x.status == item);
          filtered.forEach(x => temp.push(x));
          filteredStatus = [...temp.flat()];
          filteredData = filteredStatus;
        });
      }
    }

    //DateFilter

    if (yearly) {
      let filtered;
      let temp = [];
      let filteredDates = "";
      let ogData = filteredData;
      if (yearly.length === 1) {
        let filteredDates = ogData.filter(x => {
          let yearNow = moment(x.exchangeStartDate).year();
          return yearNow == parseInt(yearly);
        });
        filteredData = filteredDates;
      }
      if (yearly.length > 1) {
        yearly.forEach(item => {
          filtered = ogData.filter(x => {
            let yearNow = moment(x.exchangeStartDate).year();
            return yearNow == parseInt(item);
          });

          filtered.forEach(x => temp.push(x));
          filteredDates = [...temp.flat()];
          filteredData = filteredDates;
        });
      }
    }

    if (isOneTime && yearly.length !== 0) {
      oneTimeStatus = [];
      filteredData.forEach((data, i) => {
        if (!oneTimeStatus.includes(data.status.extDescription)) {
          oneTimeStatus.push(data.status.extDescription);
        }
      });
    } else {
      if (this.props.tab === "1") {
        if (yearly.length === 0) {
          oneTimeStatus = [];
        } else {
          oneTimeStatus = [];
          filteredData.forEach((data, i) => {
            if (!oneTimeStatus.includes(data.status.extDescription)) {
              oneTimeStatus.push(data.status.extDescription);
            }
          });
        }
      }
    }

    if (isRecurring && (yearly.length !== 0 || frequency.length !== 0)) {
      recurringStatus = [];
      filteredData.forEach((data, i) => {
        if (!recurringStatus.includes(data.status)) {
          recurringStatus.push(data.status);
        }
      });
    } else {
      recurringStatus = [];
      if (this.props.tab === "2") {
        if (yearly.length === 0 && frequency.length === 0) {
          recurringStatus = [];
        } else {
          recurringStatus = [];
          filteredData.forEach((data, i) => {
            if (!recurringStatus.includes(data.status)) {
              recurringStatus.push(data.status);
            }
          });
        }
      }
    }

    let filterWithSortData = filteredData;
    if(!isEmpty(this.state.sorterInfo)) {
      const sortMapper = {
        ascend: 'desc',
        descend: 'asc'
      }
      const { columnKey, order } = this.state.sorterInfo;
      filterWithSortData = orderBy(filteredData, [columnKey], [sortMapper[order]]);
    }

    this.props.exportDataUpdate({ [this.props.tab === "1" ? 'singleExchange': 'recurringExchange']: filterWithSortData });

    this.setState({
      oneTimeStatus: oneTimeStatus,
      recurringStatus: recurringStatus,
      filteredData,
      isFilterUsed: true
    });
  };

  render() {
    const {
      isFilterUsed,
      menu,
      oneTimeStatus,
      recurringStatus,
      filteredData
    } = this.state;
    return (
      <>
        <GrantSearch
          filteredSearch={this.filteredSearch}
          handleSearch={this.handleSearch}
          options={this.props.options}
          menu={menu}
          oneTimeStatus={oneTimeStatus}
          recurringStatus={recurringStatus}
          activeTab={this.props.tab}
          filteredData={filteredData}
          isFilterUsed={isFilterUsed}
        />
        {isFilterUsed ? (
          <GrantTable
            className="main investmentExchangeSortIcon"
            columns={this.props.column}
            dataSource={this.state.filteredData}
            options={this.props.column}
            pagination={false}
            scroll={{ x: 900, y: 500 }}
            onChange={(pagination, filters, sorter, extra)=> this.onChangeHandler(sorter, extra)}
          />
        ) : (
          <GrantTable
            className="main investmentExchangeSortIcon"
            columns={this.props.column}
            dataSource={this.state.original}
            options={this.props.column}
            pagination={false}
            scroll={{ x: 900, y: 500 }}
            onChange={(pagination, filters, sorter, extra)=> this.onChangeHandler(sorter, extra)}
          />
        )}
      </>
    );
  }
}
